



























































































































































import { Post, User } from 'types'
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter, State } from 'vuex-class'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'

@Component({ components: { OzIcon, OzTextButton } })
export default class SurfacePostMoreActions extends Mixins() {
  OzTextButtonColorScheme = OzTextButtonColorScheme

  @Prop() post!: Post
  @Prop() colorScheme!: 'light' | 'dark'
  @Prop({ default: true }) xOverlay!: boolean
  @State isSafari!: boolean
  @Getter isStream!: boolean
  @State isTouchable!: boolean
  @Getter canIEdit!: boolean
  @Getter canIWrite!: boolean
  @State user!: User | undefined

  get isPostAuthor(): boolean {
    return this.post.author_id === this.user?.id
  }
  get xEditPost(): boolean {
    if (this.isTouchable) return false
    return this.canIEdit || (this.canIWrite && this.isPostAuthor)
  }
  get color(): string {
    return this.post.color || 'default'
  }

  /**
   * getter for tailwind classes to color the component background
   * @returns array of 4 strings, first two are for div backgroudns on light and dark mode,
   * last two are for corner on light and dark mode.
   */
  get colorClasses(): [string, string, string, string] {
    switch (this.color) {
      case 'red':
        return ['bg-scarlet-100', 'bg-scarlet-900', 'corner-scarlet-100', 'corner-scarlet-900']
      case 'orange':
        return ['bg-canary-100', 'bg-tangerine-900', 'corner-canary-100', 'corner-tangerine-900']
      case 'green':
        return ['bg-park-100', 'bg-park-900', 'corner-park-100', 'corner-park-900']
      case 'blue':
        return ['bg-oceanic-100', 'bg-oceanic-900', 'corner-oceanic-100', 'corner-oceanic-900']
      case 'purple':
        return ['bg-grape-100', 'bg-grape-900', 'corner-grape-100', 'corner-grape-900']
      case 'default':
      default:
        return ['bg-light-ui-100', 'bg-dark-ui-100', 'corner-light-ui-100', 'corner-dark-ui-100']
    }
  }
}
